<template>
    <share-entity-dialog ref="base" collection="routines" :title="$t('routines.share_routine')"
        :shared-toast="$t('routines.shared')" />
</template>

<script>
import ShareEntityDialog from "./ShareEntityDialog";

export default {
    name: "ShareRoutineDialog",
    components: { ShareEntityDialog },
    methods: {
        show(entity) {
            this.$refs.base.show(entity)
        },
    }
}
</script>
